import _ from 'underscore';
import TrackingTemplate from '@bingads-webui-component-legacy/upgraded-url/view/trackingTemplate';

export default class extends TrackingTemplate {
  initialize(options = {}) {
    let opt = _.defaults({}, options, {
      trackingTemplate: _.clone(options.observable()),
    });

    if (_.isEmpty(options.observable())) {
      options.observable(null);
    }

    options.observable.validate = () => {
      return _.isEmpty(this.ko_model.errorMessages());
    };

    super.initialize(opt);

    this.ko_model.trackingTemplate.subscribe((val) => {
      const newValue = _.isEmpty(val) ? null : val;

      options.observable(newValue);
    });
  }
}
